/* eslint-disable jsx-a11y/alt-text */
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession, setDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import { descargarFactura } from 'actions/archivos';
import Modal from 'components/modal/Modal';
import { useModal } from 'hooks/useModal';
import Swal from 'sweetalert2';
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
import { useTranslation } from "react-i18next";
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import WebStoriesIcon from '@mui/icons-material/WebStories';
import shopify from 'images/panel/conexiones/shopify.png';
import tiendanube from 'images/panel/conexiones/tiendanube.png';
import wix from 'images/panel/conexiones/wix.png';
import woocommerce from 'images/panel/conexiones/woocommerce.png';
import amazon from 'images/panel/conexiones/amazon.png';
import mercadolibre from 'images/panel/conexiones/mercadolibre.png';
import SLUGS from 'resources/slugs';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ListItemIcon from '@mui/material/ListItemIcon';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { ListVariante, Cargando } from './Variante';
import { currency, convertStatusArticulo } from 'resources/utilities';
import { SelectorConexion } from './SelectorConexion';
import AsyncSelectTextField from 'components/Input/AsyncSelectTextField';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useUIUtils } from 'hooks/useUIUtils';
import { AsignarExistenciasArticulo } from './AsignarExistenciasArticulo';
import { AsignarPreciosArticulo } from './AsignarPreciosArticulo';

const $ = require('jquery')
$.DataTable = require('datatables.net-select')

const List = ({ history, match }) => {
    const { path } = match;
    const { t } = useTranslation("common");
    const { changeGlobalTitle } = useUIUtils()
    const [noDisponible,] = useState('NoDisponible');
    const [modalKey, setModalKey] = useState(0);
    let [articuloId, setArticuloId] = useState(0);
    let [factor, setFactor] = useState(1);
    let [dataArt, setDataArt] = useState(null);
    let [movimiento, setMovimiento] = useState(null);
    let [mensajeAsignacion, setMensajeAsignacion] = useState('');
    let [mensajeAsignacionVariante, setMensajeAsignacionVariante] = useState('');
    let [mensajeAsignacionMensaje, setMensajeAsignacionMensaje] = useState('');
    let [erp, setERP] = useState('');
    let [actualizarTabla, setActualizarTabla] = useState(false);
    let [CodigoArticulo, setCodigoArticulo] = useState('');
    let [sucursalesList, setSucursalesList] = useState(['']);
    let [archivo, setArchivo] = useState('');
    const [confSincro,] = useState(GetConfSincro(getDataSession('confSincro')));
    let [sucursalIdOri, setSucursalIdOri] = useState(getDataSession('sucursal'));
    let [sucursalIdDes, setSucursalIdDes] = useState(getDataSession('sucursal'));
    let [sucursalDuplicar, setSucursalDuplicar] = useState({ id: 0, tienda: '' });
    let [mensajeArticulosDescargados, setMensajeArticulosDescargados] = useState('');
    let [mensajeArticulosSincronizados, setMensajeArticulosSincronizado] = useState('');
    let [mensajeArticulosImportados, setMensajeArticulosImportados] = useState('');
    const [isOpenModalMarketPlace, openModalMarketPlace, closeModalMarketPlace] = useModal(false);
    const [isOpenModal, openModal, closeModal] = useModal(false);
    const [modalValor, setModalValor] = useState(false);
    const baseUrl = process.env.REACT_APP_API_URL;
    const [connection, setConnection] = useState(null);
    let [sucursalPrincipal, setSucursalPrincipal] = useState({});
    const [sucursales, setSucursales] = useState([]);
    const [tienda, setTienda] = useState('');
    const [rolClavesTienda, setRolClavesTienda] = useState([]);
    const [rolClavesPrincipal, setRolClavesPrincipal] = useState([]);
    let [asignacion, setAsignacion] = useState({
        lista_clave_tienda_id: 0,
        lista_clave_principal_id: 0,
        articulo_tienda_id: 0,
        articulo_principal_id: 0,
        variante: false,
        automatica: true
    });
    let [filtro, setFiltro] = useState('T');
    let [status, setStatus] = useState('T');
    let [buscar, setBuscar] = useState('');
    const [fechaInicio, setFechaInicio] = useState(GetFecha());
    const [fechaDescarga, setFechaDescarga] = useState(GetFecha());
    let [usaFecha, setUsaFecha] = useState(false);
    let [statusDescarga, setStatusDescarga] = useState('ACTIVE');
    let [marcaDescarga, setMarcaDescarga] = useState('');
    let [filtroTipo, setFiltroTipo] = useState('T');
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElAsignacion, setAnchorElAsignacion] = useState(null);
    const [anchorElHerramientas, setAnchorElHerramientas] = useState(null);
    const open = Boolean(anchorEl);
    const openAsignacion = Boolean(anchorElAsignacion);
    const openHerramientas = Boolean(anchorElHerramientas);
    const handleClick = (event) => { setAnchorEl(event.currentTarget); };
    const handleClickAsignacion = (event) => { setAnchorElAsignacion(event.currentTarget); };
    const handleClickHerramientas = (event) => { setAnchorElHerramientas(event.currentTarget); };
    const handleClose = () => {
        setAnchorEl(null);
        setAnchorElHerramientas(null);
        setAnchorElAsignacion(null);
    };

    function GetConfSincro(confSincroString) {
        if (!confSincroString || confSincroString === undefined || confSincroString === null) return null;

        try { return JSON.parse(confSincroString); } catch (error) { return null; }
    }

    async function getData(page) {
        await fetchConToken(`Articulos/GetList?empresa_id=${getDataSession('empresa')}&sucursal_id=${getDataSession('sucursal')}&paginas=${page}&totalXpagina=${10}&busqueda=${''}`);
    }

    const handleInputChange = ({ target }) => {
        setCodigoArticulo(target.value);
    };

    const DescargarTiendaEvent = () => {
        if (tienda?.toUpperCase() === "SHOPIFY") opcionModal('descargarArticulos');
        else DescargarTienda();

        handleClose();
    }

    const DescargarTienda = () => {
        Swal.fire({
            text: t('app.Articulos.descargarArticulos?'),
            showCancelButton: true,
            confirmButtonText: t('app.botones.descargar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (result.isConfirmed) {
                var parametros = `&fechaInicial=${tienda?.toUpperCase() === "SHOPIFY" && usaFecha ? fechaDescarga : ''}&status=${tienda?.toUpperCase() === "SHOPIFY" ? statusDescarga : ''}&marca=${tienda?.toUpperCase() === "SHOPIFY" ? marcaDescarga : ''}`;
                fetchConToken(isERP() ? `Articulos/DescargarArticulosERP?sucursal_id=${getDataSession('sucursal')}&crearNoExistentes=true` : `Articulos/DescargarArticulos?empresa_id=${getDataSession('empresa')}&sucursal_id=${getDataSession('sucursal')}${parametros}`,
                    null,
                    'POST'
                ).then(function (response) {
                    if (response.hasOwnProperty('status') && response.status === 400) {
                        Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                        return;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return;
                    }

                    Swal.fire(t('app.Articulos.SwalFire.descargando'), t('app.Articulos.SwalFire.seEstaDescargando'), 'info');
                });
            }
        });
    };

    async function eliminar(id) {
        Swal.fire({
            text: "De donde desea eliminar el articulo?",
            showCancelButton: true,
            confirmButtonText: 'Microzync',
            showDenyButton: true,
            denyButtonText: 'Ecommerce y Microzync',
            cancelButtonText: "Cancelar"
        }).then((result) => {
            var eliminar = false;
            var eliminarMk = false;
            if (result.isConfirmed) {
                eliminar = true;
                eliminarMk = false;
            }
            else if (result.isDenied) {
                eliminar = true;
                eliminarMk = true;
            }
            if (eliminar) {
                fetchConToken(`Articulos?articulo_id=${id}${eliminarMk ? "&eliminarmk=true" : ''}`, null, 'DELETE').then(function (response) {
                    if (response.hasOwnProperty('status') && response.status === 400) {
                        Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                        return;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return;
                    }
                    setActualizarTabla(true);
                    Swal.fire(t('app.SwalFire.eliminado'), t('app.Articulos.SwalFire.eliminado'), 'success');
                    setActualizarTabla(false);
                });
            }
        })
    }

    const TotalArticulos = useCallback(async () => {
        const response = await fetchConToken(`Articulos/total?sucursal_id=${getDataSession('sucursal')}`);
        setMensajeArticulosDescargados(t("app.Articulos.articulosDescargados") + ":   " + (response.total ?? 0) + "/ " + (response.total_Ecommerce ?? 0));
    }, [t])

    function getArt(articulo_id) {
        if (articulo_id && articulo_id > 0) {
            setDataArt(null);
            fetchConToken(`articulos?id=${articulo_id}&sucursal_Id=${getDataSession('sucursal')}&conDetalle=true`).then((art) => {
                if (art.hasOwnProperty('status')) {
                    Object.entries(art?.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                    return false;
                } else if (art.hasOwnProperty('codigo')) {
                    Swal.fire('Error', art.mensajes[0], 'error');
                    return;
                }

                setDataArt(art);
            });
        }
    }

    function GetFecha() {
        var curr = new Date();
        curr.setDate(curr.getDate());
        return curr.toISOString().substring(0, 10);
    }

    React.useEffect(() => {
        const connect = new HubConnectionBuilder().withUrl(baseUrl + "/notificacion", {
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets
        }).withAutomaticReconnect().build();
        setConnection(connect);
    }, [baseUrl]);

    React.useEffect(() => {
        if (connection) {
            connection.start().then(async () => {
                await connection.invoke("Add", getDataSession('empresa') + "-" + getDataSession('sucursal'));
                connection.on("ReceiveNotificacionDescarga", function (message) {
                    setMensajeArticulosDescargados(message);
                });

                connection.on("ReceiveNotificacionFinalizacion", function (_message) {
                    TotalArticulos();
                });

                connection.on("ReceiveNotificacionAsignacion", function (message) {
                    setMensajeAsignacion(message);
                    //ReloadTabla();
                });

                connection.on("ReceiveNotificacionAsignacionVariante", function (message) {
                    setMensajeAsignacionVariante(message);
                    //ReloadTabla();
                });

                connection.on("ReceiveNotificacionAsignacionTerminada", function (message) {
                    setMensajeAsignacionMensaje(message);
                    //ReloadTabla();
                });

                connection.on("DescargarSincronizarArticulo", function (message) {
                    setMensajeArticulosSincronizado(message);
                    //ReloadTabla();
                });

                connection.on("ImportarArticulos", function (message) {
                    setMensajeArticulosImportados(message);
                });


                connection.on("ReceiveMessage", function (message) {
                    setMensajeArticulosDescargados(message);
                    //ReloadTabla();
                });
            })
                .catch((error) => console.log(error));
        }
    }, [connection, TotalArticulos]);

    React.useEffect(() => {
        getPrincipal();
        TotalArticulos();
        //getData(1);
        getSucursales();
        $('.dataTables_length').append("&nbsp; &nbsp;<label>Estatus:" +
            "<select class='select-filter-status' >" +
            "   <option value='Activos'>" + t('app.Articulos.filtros.activos') + "</option>" +
            "    <option value='Inactivos'>" + t('app.Articulos.filtros.inactivos') + "</option>" +
            "    <option value='Pendientes'>" + t('app.Articulos.filtros.pendientes') + "</option>" +
            "</select></label>");
        $('.dataTables_length').append("&nbsp; &nbsp;<label>" + t('app.Articulos.filtros.filtro') + ":" +
            "<select class='select-filter-filtro' >" +
            "    <option value='vacio'></option>" +
            "    <option value='SinClaveProdServ'>" + t('app.Articulos.filtros.sinClaveSat') + "</option>" +
            "    <option value='SinNoIdentificacion'>" + t('app.Articulos.filtros.sinNumIdenti') + "</option>" +
            "    <option value='Sinclaveunidad'>" + t('app.Articulos.filtros.sinClaveUnidad') + "</option>" +
            "    <option value='SinSKU'>" + t('app.Articulos.filtros.sinSku') + "</option>" +
            "    <option value=>" + t('app.Articulos.filtros.requiereRevision') + "</option>" +
            "</select></label>");
        $("body").on("change", ".select-filter-status", function () {
            var table = $('#table-js').DataTable();
            table.columns(1).search(this.value).draw();
        });
        $("body").on("change", ".select-filter-filtro", function () {
            var table = $('#table-js').DataTable();
            table.columns(2).search(this.value).draw();
        });
    }, [TotalArticulos, t]);

    React.useEffect(() => {
        changeGlobalTitle(t('app.Articulos.lista.titulo'), t('app.Articulos.lista.descripcion'))
        getConfigERP();
        getTiendaBySucursal();
    }, [changeGlobalTitle, t]);

    const getSucursales = async () => {
        const responseSucursal = await fetchConToken(`Sucursales/List`);
        setSucursalesList(responseSucursal);
    };

    const DescargarArticulo = () => {
        fetchConToken(isERP() ? `Articulos/DescargarArticuloERPBySKU?sucursal_id=${getDataSession('sucursal')}&sku=${CodigoArticulo}&crearNoExistentes=true&autoAsignarBySKU=true` :
            `Articulos/DescargarArticulos?empresa_id=${getDataSession('empresa')}&sucursal_id=${getDataSession('sucursal')}&clave_articulo=${CodigoArticulo}`,
            null, 'POST').then(function (response) {
                getData(1);
                if (response.hasOwnProperty('status') && response.status === 400) {
                    Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                    return;
                } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                    Swal.fire('Error', response.mensajes[0], 'error');
                    return;
                }

                Swal.fire(t('app.SwalFire.exitoso'), t('app.Articulos.SwalFire.articuloDescargado'), 'success');
                setActualizarTabla(true);
                setActualizarTabla(false);
                closeModal();
            });
    };

    const AsignacionAutomatica = () => {
        if (asignacion.lista_clave_tienda_id === 0) {
            Swal.fire('Info', 'Seleccione el rol de clave de la tienda', 'info');
            return;
        }
        if (asignacion.lista_clave_principal_id === 0) {
            Swal.fire('Info', 'Seleccione el rol de clave de la principal', 'info');
            return;
        }

        fetchConToken(`Articulos/AsignacionAutArticulos?sucursal_id=${getDataSession('sucursal')}&lista_clave_tienda_id=${asignacion.lista_clave_tienda_id}&lista_clave_principal_id=${asignacion.lista_clave_principal_id}`, null, 'PUT');
        Swal.fire('Sincronizacion Iniciada', '', 'success');
        setActualizarTabla(true);
        setActualizarTabla(false);
    };

    const getPrincipal = () => {
        fetchConToken(`Sucursales/Principal`).then(response => {
            setSucursalPrincipal(response);
            setDataSession('sucursalPrincipal', response.id);
            validarExisteSucursalPrincipal();
        });
    }

    const AsignacionArticulo = () => {
        if (asignacion.automatica !== true) asignacion.automatica = asignacion.automatica === "true";

        fetchConToken(`Articulos/AsignarArticulo`, asignacion, 'PUT').then(response => {
            if (response.hasOwnProperty('status')) {
                Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return false;
            }

            setActualizarTabla(true);
            Swal.fire('Asignación completa', response.articulo, 'success');
            setActualizarTabla(false);
        });
    };

    const actualizarCodigosXSucursal = () => {
        if (sucursalIdOri === sucursalIdDes) {
            Swal.fire(t('app.botones.atencion'), t('app.botones.seleccioneConexionesDif'), 'info');
            return;
        }

        Swal.fire({
            text: t('app.Articulos.actualizarCodigos?'),
            showCancelButton: true,
            confirmButtonText: t('app.botones.actualizar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (result.isConfirmed) {
                fetchConToken(`articulos/ActualizarCodigosSucursal?empresa_id=${getDataSession('empresa')}&sucursal_ori=${sucursalIdOri}&sucursal_des=${sucursalIdDes}`, true).then((_res) => {
                    getData(1);
                    Swal.fire(t('app.SwalFire.procesando'), t('app.Articulos.actualizandoCodigos'), 'success');
                })
                //.catch(alertService.error);
            }
        });
    };

    const actualizarCodigos = () => {
        if (!archivo || archivo === undefined || archivo === null) {
            Swal.fire('Error', 'El archivo no se a seleccionado', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('empresa_id', getDataSession('empresa'));
        formData.append('sucursal_id', sucursalIdDes);
        formData.append('tipo', 'excel');
        formData.append('FileToUpload', archivo[0], archivo[0].name);
        fetchConToken('articulos/ActualizarCodigos', formData, 'POST', true);
        Swal.fire(t('app.SwalFire.procesando'), t('app.Articulos.actualizandoCodigos'), 'success');
        closeModal();
    };

    const sincronizarArticulos = () => {
        if (!archivo || archivo === undefined || archivo === null) {
            Swal.fire('Error', 'El archivo no se a seleccionado', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('empresa_id', getDataSession('empresa'));
        formData.append('sucursal_id', sucursalIdDes);
        formData.append('tipo', 'excel');
        formData.append('FileToUpload', archivo[0], archivo[0].name);
        fetchConToken('articulos/Sincronizar', formData, 'POST', true);
        Swal.fire(t('app.SwalFire.procesando'), 'Sincronizando articulos', 'success');
        closeModal();
    };

    const sincronizarArticulosCanal = () => {
        Swal.fire({
            title: 'Se sincronizara los articulos de la conexion seleccionado\nSeleccione que desea sincronizar',
            text: '',
            showDenyButton: true,
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Stock',
            denyButtonText: `Precio`,
            cancelButtonText: 'Stock y Precios'
        }).then((result) => {
            console.log(result);
            if (result.dismiss === 'close') return;

            let sincronizar_stock = result.isDismissed ? true : result.isConfirmed;
            let sincronizar_precio = result.isDismissed ? true : result.isDenied;
            fetchConToken(`Articulos/SincronizarBySucursal?sucursal_id=${sucursalIdDes}&sincronizar_stock=${sincronizar_stock}&sincronizar_precio=${sincronizar_precio}`, null, 'POST', true);
            Swal.fire(t('app.SwalFire.procesando'), 'Sincronizando articulos', 'success');
            closeModal();
        })
    };

    const actualizarEstatusFull = () => {
        if (!archivo || archivo === undefined || archivo === null) {
            Swal.fire('Error', 'El archivo no se a seleccionado', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('empresa_id', getDataSession('empresa'));
        formData.append('sucursal_id', sucursalIdDes);
        formData.append('tipo', 'excel');
        formData.append('FileToUpload', archivo[0], archivo[0].name);
        fetchConToken('articulos/ActualizarEstatusFull', formData, 'POST', true);
        Swal.fire(t('app.SwalFire.procesando'), 'Actualizando articulos', 'success');
        closeModal();
    };

    const importarArticulos = () => {
        if (!archivo || archivo === undefined || archivo === null) {
            Swal.fire('Error', 'El archivo no se a seleccionado', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('empresa_id', getDataSession('empresa'));
        formData.append('sucursal_id', getDataSession('sucursalPrincipal'));
        formData.append('tipo', 'excel');
        formData.append('FileToUpload', archivo[0], archivo[0].name);
        fetchConToken('articulos/ImportarArticulos', formData, 'POST', true);
        Swal.fire(t('app.SwalFire.procesando'), 'Importando articulos', 'success');
        closeModal();
    };

    const importarPreciosExistencias = () => {
        if (!archivo || archivo === undefined || archivo === null) {
            Swal.fire('Error', 'El archivo no se a seleccionado', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('empresa_id', getDataSession('empresa'));
        formData.append('sucursal_id', sucursalIdOri);
        formData.append('tipo', 'excel');
        formData.append('FileToUpload', archivo[0], archivo[0].name);
        var url = modalValor === 'importarExistenciasExcel' ? 'existencias/ImportarExistencias' : (modalValor === 'importarExistenciasPreciosExcel' ? 'articulos/ImportarExistenciasPrecios' : 'precioArticulo/ImportarPrecios');
        fetchConToken(url, formData, 'POST', true);
        Swal.fire(t('app.SwalFire.procesando'), 'Importando articulos', 'success');
        closeModal();
    }

    const importarFactor = () => {
        if (!archivo || archivo === undefined || archivo === null) {
            Swal.fire('Error', 'El archivo no se a seleccionado', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('empresa_id', getDataSession('empresa'));
        formData.append('sucursal_id', sucursalIdOri);
        formData.append('tipo', 'excel');
        formData.append('FileToUpload', archivo[0], archivo[0].name);
        fetchConToken('articulos/ActualizarFactor', formData, 'POST', true);
        Swal.fire(t('app.SwalFire.procesando'), 'Importando articulos', 'success');
        closeModal();
    }

    function handleChangeFiltros(e) {
        setFiltro(e.target.value);
    }

    function handleChangeStatus(e) {
        setStatus(e.target.value);
    }

    function handleChangeStatusDescarga(e) {
        setStatusDescarga(e.target.value);
    }

    function handleChangeMarcaDescarga(e) {
        setMarcaDescarga(e.target.value);
    }

    function handleChangeOri(e) {
        setSucursalIdOri(e.target.value);
    }

    function handleChangeDes(e) {
        setSucursalIdDes(e.target.value);
    }

    const handleInputChangeFileConfig = ({ target }) => {
        setArchivo(target.files);
    };

    function opcionModal(opcion) {
        if (opcion === 'AsignacionAutomatica') cargarRolesClaves();

        setModalKey(prev => prev + 1);
        setMarcaDescarga('');
        setModalValor(opcion);

        if (opcion === 'duplicarArticulosMatriz') openModalMarketPlace(); else openModal();
    }

    const cargarRolesClaves = async () => {
        const responseSucursal = await fetchConToken(`RolesClaves/GetList?sucursal_Id=${getDataSession('sucursal')}`);
        setRolClavesTienda(responseSucursal);

        const responsePrincipal = await fetchConToken(`RolesClaves/GetListPrincipal`);
        setRolClavesPrincipal(responsePrincipal);
    };

    function descargarPlantilla() {
        var all = true;
        switch (modalValor) {
            case 'actualizacionCodigosExcel':
                descargarFactura(0, 'articulos/PlantillaActualizacion', "plantilla_carga_codigos_articulos.xlsx");
                break;
            case 'sincronizacionExcel':
                descargarFactura(0, 'articulos/PlantillaSincronizar', "plantilla_sincronizar_articulos.xlsx");
                break;
            case 'ActualizarEstatusFullExcel':
                descargarFactura(0, 'articulos/PlantillaActualizarEstatusFull', "plantilla_actualizar_status_full.xlsx");
                break;
            case 'importarArticulosExcel':
                descargarFactura(0, 'articulos/PlantillaImportarArticulos', "plantilla_importar_articulos.xlsx");
                break;
            case 'importarFactorExcel':
                descargarFactura(0, 'articulos/PlantillaImportarFactor', "plantilla_importar_factor.xlsx");
                break;
            case 'importarExistenciasExcel':
                //if (!(filtro === 'T' && status === 'T' && (!buscar || buscar === ''))) {
                //    Swal.fire({
                //        text: '¿Desea ?',
                //        showCancelButton: true,
                //        confirmButtonText: '',
                //        cancelButtonText: ''
                //    }).then((result) => all = result.isConfirmed);
                //}

                Swal.fire({ title: "El proceso puede tardar varios minutos\nNo cerrar el navegador...", icon: "info", showConfirmButton: false, timer: 1000 });
                descargarFactura(0, `existencias/PlantillaImportarExistencias${(all ? '' : `&filtro=${filtro}&status=${status}&busqueda=${buscar}`)}`, "plantilla_importar_existencias.xlsx");
                break;
            case 'importarPreciosExcel':
                //if (!(filtro === 'T' && status === 'T' && (!buscar || buscar === ''))) {
                //    Swal.fire({
                //        text: '¿Desea ?',
                //        showCancelButton: true,
                //        confirmButtonText: '',
                //        cancelButtonText: ''
                //    }).then((result) => all = result.isConfirmed);
                //}

                Swal.fire({ title: "El proceso puede tardar varios minutos\nNo cerrar el navegador...", icon: "info", showConfirmButton: false, timer: 1000 });
                descargarFactura(0, `precioArticulo/PlantillaImportarPrecios${(all ? '' : `&filtro=${filtro}&status=${status}&busqueda=${buscar}`)}`, "plantilla_importar_precios.xlsx");
                break;
            case 'importarExistenciasPreciosExcel':
                //if (!(filtro === 'T' && status === 'T' && (!buscar || buscar === ''))) {
                //    Swal.fire({
                //        text: '¿Desea ?',
                //        showCancelButton: true,
                //        confirmButtonText: '',
                //        cancelButtonText: ''
                //    }).then((result) => all = result.isConfirmed);
                //}

                //Swal.fire({ title: "El proceso puede tardar varios minutos\nNo cerrar el navegador...", icon: "info", showConfirmButton: false, timer: 1000 });
                descargarFactura(0, 'articulos/PlantillaImportarExistenciasPrecios', "plantilla_importar_existencias_precios.xlsx");
                break;
            default: break;
        }
    }

    function exportarArticulos(asignados) {
        var all = true;
        //if (!(filtro === 'T' && status === 'T' && (!buscar || buscar === ''))) {
        //    Swal.fire({
        //        text: '¿Desea exportar los articulos usando los filtros actuales?',
        //        showCancelButton: true,
        //        confirmButtonText: 'Si',
        //        cancelButtonText: 'No'
        //    }).then((result) => all = result.isConfirmed);
        //}

        handleClose();
        Swal.fire({ title: "El proceso puede tardar varios minutos\nNo cerrar el navegador...", icon: "info", showConfirmButton: false, timer: 2000 });
        if (!asignados) descargarFactura(0, `articulos/DescargaExcel?sucursal_id=${getDataSession('sucursal')}${(all ? '' : `&filtro=${filtro}&status=${status}&busqueda=${buscar}`)}`, "articulos.xlsx");
        else descargarFactura(0, `articulos/DescargaCSVAsignados?sucursal_id=${getDataSession('sucursal')}`, "articulos.csv");
    }

    function PublicadorMasivo(eCommerce) {
        if (noDisponible === eCommerce) {
            Swal.fire('Tienda no disponible');
            return;
        }

        if (modalValor === 'pulicadorMasivo') {
            history.push(`${SLUGS.articulos}/publicador/${eCommerce}`);
            return;
        }

        setModalKey(prev => prev + 1);
        setSucursalDuplicar({ ...sucursalDuplicar, tienda: eCommerce.toUpperCase() });
        getSucursalesTienda(eCommerce);
        setModalValor(modalValor === '' ? 'duplicarArticulo' : 'duplicarArticulos');
    }

    function DuplicarArticulosMatriz(eCommerce) {
        if (noDisponible === eCommerce) {
            Swal.fire('Tienda no disponible');
            return;
        }

        setModalKey(prev => prev + 1);
        getSucursalesTienda(eCommerce);
        setModalValor('enviarArticulosDeMatriz');
        setSucursalDuplicar({ ...sucursalDuplicar, tienda: eCommerce.toUpperCase() });
    }

    const duplicarArticulo = (articulo_id) => {
        setSucursales(null);
        setArticuloId(articulo_id);
        setModalValor('duplicarArticuloEcommerce');
        setModalKey(prev => prev + 1);
        openModalMarketPlace();
    }

    const duplicarArticuloOnClick = () => {
        let sucursales_ids = sucursales?.filter(x => x.checked);
        if (!sucursales_ids || sucursales_ids.length === 0) {
            Swal.fire('Error', 'Debe tener seleccionado por lo menos una conexion', 'error');
            return;
        }

        setSucursalDuplicar({ ...sucursalDuplicar, id: sucursales_ids.find(x => x.checked).id });
        //if (modalValor === 'duplicarArticulos') duplicarArticulosOnClick(); else 
        genArticulos(sucursales_ids);
    }

    const duplicarArticulosMatrizOnClick = () => {
        let sucursales_ids = sucursales?.filter(x => x.checked);
        if (!sucursales_ids || sucursales_ids.length === 0) {
            Swal.fire('Error', 'Debe tener seleccionado por lo menos una conexion', 'error');
            return;
        }

        setSucursalDuplicar({ ...sucursalDuplicar, id: sucursales_ids.find(x => x.checked).id });
        genArticulos(sucursales_ids);
    }

    // const duplicarArticulosOnClick = async (conexiones) => await fetchConToken('Articulos/GenerarArticulos', getArticuloPublicador(conexiones), 'POST').then((resp) => {
    //     if (resp.codigo === 200) {
    //         setDataSession('tienda', sucursalDuplicar.tienda.toUpperCase());
    //         setDataSession('sucursal', resp.data[0].sucursal_Id);
    //         history.push(`${SLUGS.articulos}/edit/${resp.data[0].id}`);
    //         return;
    //     }

    //     Swal.fire('Error', resp.mensajes[0] ?? 'Error al generar los articulos', 'error');
    // }).catch((e) => { Swal.fire('Error', e, 'error'); });

    const handleInputAsignacion = ({ target }) => {
        setAsignacion({
            ...asignacion,
            [target.name]: target.value
        });
    };

    function asignarArticulo(articulo_id) {
        cargarRolesClaves();
        setAsignacion({
            ...asignacion,
            articulo_tienda_id: articulo_id
        });

        setModalKey(prev => prev + 1);
        setModalValor('AsignacionArticulo');
        openModal();
    }

    function verVentasArticulo(articulo_id) {
        if (articulo_id !== "0") setArticuloId(articulo_id);

        setModalKey(prev => prev + 1);
        setModalValor('verVentasArticulo');
        setMovimiento('VENTA');
        openModal();
    }

    function verMovimientoArticulo(articulo_id) {
        setArticuloId(articulo_id);
        setModalKey(prev => prev + 1);
        setModalValor('verVentasArticulo');
        setMovimiento(null);
        openModal();
    }

    function verVariantesArticulo(articulo_id) {
        setDataArt(null);
        setArticuloId(articulo_id);
        getArt(articulo_id);
        setModalKey(prev => prev + 1);
        setModalValor('verVariantesArticulo');
        openModal();
    }

    function verHistorial(articulo_id) {
        setDataArt(null);
        setArticuloId(articulo_id);
        setModalKey(prev => prev + 1);
        setModalValor('verHistorialArticulo');
        openModal();
    }

    function asignarExistenciasArt(articulo_id) {
        getArt(articulo_id);
        setArticuloId(articulo_id);
        setModalKey(prev => prev + 1);
        setModalValor('asignarExistencias');
        openModal();
    }

    function asignarPreciosArt(articulo_id) {
        getArt(articulo_id);
        setArticuloId(articulo_id);
        setModalKey(prev => prev + 1);
        setModalValor('asignarPrecios');
        openModal();
    }

    function getArticulo(id) {
        setAsignacion({
            ...asignacion,
            articulo_principal_id: id
        });
    }

    const asignarImpuestos16 = () => {
        Swal.fire({
            text: "¿Desea asignar el impuesto IVA 16% a todos los articulos?",
            showCancelButton: true,
            confirmButtonText: "Si, asignalo",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                fetchConToken(`articulos/AsignarImpuestosXsucursal?sucursal_id=${getDataSession('sucursal')}`, null, 'PUT').then((response) => {
                    if (response.hasOwnProperty('status') && response.status === 400) {
                        Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                        return;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return;
                    }

                    Swal.fire("Exito", "Impuestos Asignados", 'success');
                })
            }
        });
    }

    const ActualizarArticulo = (articulo_id) => {
        Swal.fire({
            title: isERP() ? '¿Desea actualizar la información de este artículo?' : t('app.Articulos.SwalFire.actualizarArt?'),
            text: isERP() ? '' : t('app.Articulos.SwalFire.infoActArt'),
            showCancelButton: true,
            confirmButtonText: t('app.botones.actualizar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (result.isConfirmed) {
                fetchConToken(
                    isERP() ? `Articulos/DescargarArticuloERPByArtId?sucursal_id=${getDataSession('sucursal')}&articulo_id=${articulo_id}&crearNoExistentes=true&autoAsignarBySKU=true` :
                        `Articulos/DescargarArticulos?empresa_id=${getDataSession('empresa')}&sucursal_id=${getDataSession('sucursal')}&articulo_id=${articulo_id}`,
                    null,
                    'POST'
                ).then(function (response) {
                    getArticulo();
                    if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                    else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                    else {
                        Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
                        setActualizarTabla(true);
                        setActualizarTabla(false);
                    }
                });
            }
        })
    };

    const getTiendaBySucursal = () => fetchConToken(`ConfiguracionesSucursales?sucursal_id=${getDataSession('sucursal')}&nombre=TIENDA`).then(response => {
        if (response && response.valor) setTienda(response.valor);
    });

    const getSucursal = (tienda, parametros) => fetchConToken(`Sucursales/GetListByTienda?empresa_id=${getDataSession('empresa')}&tienda=${tienda}&${parametros}`);

    async function getSucursalesTienda(tiendaParam) {
        setTienda(tiendaParam);
        const response = await getSucursal(tiendaParam, 'includeTienda=true&includeMatriz=false&includeConfSinc=true');
        setSucursales(response);
    }

    const getArticuloPublicador = (conexiones) => {
        var sucursales_ids = [];
        var usaFactor = false;
        var factores = [];
        if (conexiones?.length > 0) conexiones.forEach(element => {
            sucursales_ids.push(element.id);
            var _factor = element.factor ? Number(element.factor) : 1;
            _factor = (isNaN(_factor) ? 1 : _factor);
            factores.push(_factor);
            if (_factor > 1) usaFactor = true;
        });

        return { tienda: tienda, sucursal_id: getDataSession('sucursal'), articulos_ids: [articuloId], sucursales_ids: sucursales_ids, factores: (usaFactor ? factores : null), isMatrizToEcommerce: (modalValor === 'enviarArticulosDeMatriz') };
    }

    const genArticulos = async (conexiones) => await fetchConToken('Articulos/GenerarArticulos', getArticuloPublicador(conexiones), 'POST').then((resp) => {
        if (resp.codigo === 200) {
            if (modalValor === 'enviarArticulosDeMatriz') {
                Swal.fire('Exito', `Se inicio el proceso para enviar los articulos de principal a ${tienda}`, 'success');
                closeModalMarketPlace();
                return;
            }

            setDataSession('tienda', sucursalDuplicar.tienda.toUpperCase());
            setDataSession('sucursal', resp.data[0].sucursal_Id);
            history.push(`${SLUGS.articulos}/edit/${resp.data[0].id}`);
            return;
        }

        Swal.fire('Error', resp.mensajes[0] ?? 'Error al generar los articulos', 'error');
    }).catch((e) => { Swal.fire('Error', e, 'error'); });

    const desvincularArticulo = (articulo_id) => {
        if (getDataSession('sucursal') !== getDataSession('sucursalPrincipal')) {
            Swal.fire({
                title: `¿Desea desvincular la publicacion?`,
                showCancelButton: true,
                confirmButtonText: 'Desvincular',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    fetchConToken(`Articulos/DesvincularArticulo`, { articulo_id: articulo_id, es_sucursal_principal: false }, 'PUT')
                        .then((response) => {
                            if (response.hasOwnProperty('status')) {
                                Object.entries(response?.errors).forEach(([, value]) => {
                                    Swal.fire('Error', value[0], 'error');

                                });
                                return false;
                            } else if (response.hasOwnProperty('codigo')) {
                                Swal.fire('Error', response.mensajes[0], 'error');
                                return false;
                            }

                            Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
                            setActualizarTabla(true);
                            setActualizarTabla(false);
                        })
                }
            });

            return;
        }

        Swal.fire({
            title: `¿Desea desvincular las publicaciones relacionadas con el articulo seleccionado?`,
            showCancelButton: true,
            confirmButtonText: 'Desvincular',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchConToken(`Articulos/DesvincularArticulo`, { articulo_id: articulo_id, es_sucursal_principal: true }, 'PUT')
                    .then((response) => {
                        if (response.hasOwnProperty('status')) {
                            Object.entries(response?.errors).forEach(([key, value]) => {
                                Swal.fire('Error', value[0], 'error');

                            });
                            return false;
                        } else if (response.hasOwnProperty('codigo')) {
                            Swal.fire('Error', response.mensajes[0], 'error');
                            return false;
                        }

                        Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
                        setActualizarTabla(true);
                        setActualizarTabla(false);
                    })
            }
        });
        //Swal.fire('Atencion', 'No se pueden desvincular articulos de la conexion principal', 'warning');
    }

    const sincronizarExistencia = (articulo_id) => {
        Swal.fire({
            title: '¿Desea sincronizar la existencia de este artículo?',
            showCancelButton: true,
            confirmButtonText: t('app.botones.actualizar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(
                `Articulos/SincronizarExistencia?articulo_id=${articulo_id}&sucursal_id=${getDataSession('sucursal')}`,
                null,
                'PUT'
            ).then(function (response) {
                if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                else {
                    Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                }
            });
        })
    }

    const sincronizarPrecio = (articulo_id) => {
        Swal.fire({
            title: '¿Desea sincronizar el precio de este artículo?',
            showCancelButton: true,
            confirmButtonText: t('app.botones.actualizar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(
                `Articulos/SincronizarPrecio?articulo_id=${articulo_id}&sucursal_id=${getDataSession('sucursal')}`,
                null,
                'PUT'
            ).then(function (response) {
                if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                else {
                    Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                }
            });
        })
    }

    const cambiarStatusFull = (articulo_id) => {
        Swal.fire({
            title: '¿Desea cambiar el estatus de FULL de este artículo?',
            showCancelButton: true,
            confirmButtonText: t('app.botones.actualizar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(
                `Articulos/ActualizarEstatusFullByid?articulo_id=${articulo_id}&sucursal_id=${getDataSession('sucursal')}`,
                null,
                'POST'
            ).then(function (response) {
                if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                else {
                    Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                }
            });
        })
    }

    const cambiarFactor = (articulo_id, _factor) => {
        setModalKey(prev => prev + 1);
        setModalValor('AsignarFactorArt');
        setArticuloId(articulo_id);
        setFactor(_factor);
        openModal();
    }

    const duplicarArtMatriz = (articulo_id) => {
        Swal.fire({
            title: '¿Desea enviar el articulo a matriz?',
            showCancelButton: true,
            confirmButtonText: 'Enviar',
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(`Articulos/DuplicarArtiuloById?articulo_id=${articulo_id}&sucursal_id=${getDataSession('sucursal')}`, null, 'POST').then(function (response) {
                if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                else {
                    Swal.fire('Exito', 'Proceso iniciado correctamente', 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                }
            });
        })
    }

    const handleChangeFactor = (e) => {
        const numero = e.target.value;
        if (/^\d*$/.test(numero)) setFactor(numero);
    }

    const asignarFactor = () => {
        if (factor < 1) {
            Swal.fire('Error', 'El factor debe ser mayor o igual a 1', 'error');
            return;
        }

        fetchConToken(`Articulos/ActualizarFactorById?articulo_id=${articuloId}&sucursal_id=${getDataSession('sucursal')}&factor=${factor}`, null, 'POST').then(response => {
            if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
            else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
            else {
                Swal.fire('Exito', t('app.Articulos.SwalFire.artActualizado'), 'success');
                closeModal();
                Swal.fire({
                    title: '¿Desea sincronizar este artículo?',
                    showCancelButton: true,
                    confirmButtonText: t('app.botones.actualizar'),
                    cancelButtonText: t('app.botones.cancelar')
                }).then((result) => {
                    if (!result.isConfirmed) return;

                    fetchConToken(
                        `Articulos/SincronizarByArticulo?articulo_id=${articuloId}&sucursal_id=${getDataSession('sucursal')}`,
                        null,
                        'POST'
                    ).then(function (response) {
                        if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                        else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                    });
                })
            }
        });
    }

    const DuplicarArtiulos = () => {
        if (getDataSession('sucursal') !== getDataSession('sucursalPrincipal')) {
            DuplicarArtiulosMatriz();
            return;
        }

        opcionModal('duplicarArticulosMatriz');
    }

    const DuplicarArtiulosMatriz = () => {
        Swal.fire({
            title: '¿Desea enviar articulos a matriz?',
            showCancelButton: true,
            confirmButtonText: 'Enviar',
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(`Articulos/DuplicarArtiulos?sucursal_id=${getDataSession('sucursal')}`, null, 'POST').then(function (response) {
                if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                else {
                    Swal.fire('Exito', 'Proceso iniciado correctamente', 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                }
            });
        })
    }

    const handleClickPadres = (c) => {
        var url = `${path}/referencias/${c.articulo_Id}?sucursal=${getDataSession('sucursal')}`;
        setDataSession("sucursal", c.id);
        history.push(url);
    };

    const handleInputChangeFechaInicio = ({ target }) => {
        setFechaInicio(target.value);
    };

    const handleInputChangeFechaDescarga = ({ target }) => {
        setFechaDescarga(target.value);
    };

    function handleChangeTipo(e) {
        setFiltroTipo(e.target.value);
    }

    const handelChangeSelect = ({ target }) => {
        setUsaFecha(target.checked);
    }

    function GetFiltroTipo() {
        return filtroTipo === 'T' ? '' : `&tipo=${filtroTipo}`;
    }

    function getConfigERP() {
        fetchConToken(`ConfiguracionesSucursales?sucursal_id=${getDataSession('sucursal')}&nombre=ERP`).then((r) => setERP(r.valor));
    }

    function isERP() {
        return erp === 'OKCAR' || erp === 'SICARX';
    }

    function esPrincipal() {
        return getDataSession('sucursal') === getDataSession('sucursalPrincipal');
    }

    function usaFactor() {
        return confSincro && confSincro.usa_Factor && confSincro.usa_Factor === 'S';
    }

    function usaSelectFull() {
        return confSincro && tienda === "MERCADOLIBRE" && confSincro.select_Arts_Full && confSincro.select_Arts_Full === 'S';
    }

    function usaSincExistencias() {
        return confSincro && confSincro.sinc_Existencias_To_Api && confSincro.sinc_Existencias_To_Api === 'S';
    }

    function usaSincPrecios() {
        return confSincro && confSincro.sinc_Precios_To_Api && confSincro.sinc_Precios_To_Api === 'S';
    }

    function movimientoH(value) {
        switch (value) {
            case 'ARTICULO_STOCK': return 'ARTICULO STOCK';
            case 'ARTICULO_PRECIO': return 'ARTICULO PRECIO';
            case 'ARTICULO_VARIANTE': return 'VARIANTE';
            case 'ARTICULO_VARIANTE_STOCK': return 'VARIANTE STOCK';
            case 'ARTICULO_VARIANTE_PRECIO': return 'VARIANTE PRECIO';
            default: return value;
        }
    }

    function movimientoTipo(value) {
        switch (value) {
            case 0: return 'AGREGADO';
            case 1: return 'ACTUALIZADO';
            case 2: return 'DESCARGADO';
            case 3: return 'FOLIADO';
            case 4: return 'FACTURADO';
            case 5: return 'OMITIDO';
            case 6: return 'RECIBIDO';
            case 7: return 'CONSTESTADO';
            case 8: return 'ELIMINADO';
            case 9: return 'CANCELADO';
            case 10: return 'ERROR';
            default: return value;
        }
    }

    function movimientoClave(row, value) {
        switch (row.movimiento) {
            case 'VENTA': return row.venta ? <a href={`${SLUGS.remisiones + '/edit/' + row.venta?.id}`}>{row.venta?.no_Orden}</a> : value;
            case 'ARTICULO':
            case 'ARTICULO_STOCK':
            case 'ARTICULO_PRECIO': return row.articulo ? <a href={`${SLUGS.articulos + '/edit/' + row.articulo?.id}`}>{row.articulo?.clave}</a> : value;
            case 'ARTICULO_VARIANTE':
            case 'ARTICULO_VARIANTE_STOCK':
            case 'ARTICULO_VARIANTE_PRECIO': return row.articulo_Variante ? <a href={`${SLUGS.articulos + '/edit/' + row.articulo_Variante?.articulo_Id}`}>{row.articulo_Variante?.clave}</a> : value;
            default: return value;
        }
    }

    function GetFoliosERP(row) {
        if (row.venta.documento_FoliosOrigen && row.venta.documento_FoliosOrigen.length > 0) return row.venta.documento_FoliosOrigen?.map(objeto => objeto.erp_Folio)?.join(', ');

        return '~';
    }

    function DatosExtra(row) {
        switch (row.movimiento) {
            case 'VENTA': return !row.venta ? '' :
                <ListItemText
                    primary={`Folio: ${row.venta.folio},  Folio ERP: ${GetFoliosERP(row)},  Fecha: ${moment(row.venta.fecha_Orden).format('DD/MM/Y')}`}
                    secondary={
                        <React.Fragment>
                            <Typography component="span" variant="body2" sx={{ color: 'text.primary', display: 'inline' }}>{row.venta.cliente?.nombre ?? ''},</Typography>
                            &nbsp;{`Importe Total: ${currency(row.venta.importe_Total)},  Estatus: ${row.venta.estatus}`}
                        </React.Fragment>
                    }
                />;
            case 'ARTICULO':
            case 'ARTICULO_STOCK':
            case 'ARTICULO_PRECIO': return !row.articulo ? '' :
                <ListItemText
                    primary={`${row.articulo.nombre},  SKU: ${row.articulo.sku}`}
                    secondary={`Precio: ${currency(row.articulo.costo_Unidad)},  Exist. Act.: ${row.articulo.existencias},  Estatus: ${row.articulo.estatus}`}
                />;
            case 'ARTICULO_VARIANTE':
            case 'ARTICULO_VARIANTE_STOCK':
            case 'ARTICULO_VARIANTE_PRECIO': return !row.articulo_Variante ? '' :
                <ListItemText
                    primary={`${row.articulo_Variante.nombre},  SKU: ${row.articulo_Variante.sku}`}
                    secondary={`Precio: ${currency(row.articulo_Variante.precio)},  Exist. Act.: ${row.articulo_Variante.existencias},  Estatus: ${row.articulo_Variante.estatus}`}
                />;
            default: return '';
        }
    }

    function RowConexiones(value) {
        return (<FormControl fullWidth sx={{ m: 1, minWidth: 50 }} size="small">
            <InputLabel id="almacen-multiple-checkbox-label">{value?.length}</InputLabel>
            <Select
                labelId="almacen-multiple-checkbox-label"
                id="almacen-multiple-checkbox"
                onChange={handleChangeStatus}
                label="Estatus"
            >
                {value?.map((c) => (<MenuItem key={c.id} value={c.id} ><ListItemButton onClick={() => { handleClickPadres(c) }} primary={c.nombre}>{c.nombre}</ListItemButton></MenuItem>))}
            </Select>
        </FormControl>);
    }

    //{ field: 'clave_Prod_Serv', headerName: 'Clave Prod. Serv.', flex: 1 },
    //{ field: 'no_Identificacion', headerName: 'No. Identificacion', flex: 1 },
    //{ field: 'clave_Unidad', headerName: 'Clave Unidad', flex: 1 },
    //{ field: 'requiere_Revision', headerName: 'Requiere Revision', flex: 1, type: 'boolean' },
    const columns = [
        {
            renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path,
            opciones: `editar,${(!esPrincipal() ? "asignar,asignarmanual," : "")}verVentasArticulo,kardex,verVariantesArticulo,verHistorial,actualizararticulo,asignarExistencias${((usaSincExistencias() || esPrincipal()) ? ",sincronizarExistencia" : "")},asignarPrecios${((usaSincPrecios() || esPrincipal()) ? ",sincronizarPrecio" : "")},duplicarArticulo,desvincular,eliminar,${(usaFactor() ? "cambiarFactor" : "")}${(usaSelectFull() ? ",cambiarStatusFull" : "")}${(!esPrincipal() ? ",duplicarArtMatriz" : "")}`,
            asignarAutomatico: asignarArticulo, verVentasArticulo: verVentasArticulo, verMovimientoArticulo: verMovimientoArticulo, verVariantesArticulo: verVariantesArticulo, verHistorial: verHistorial, actualizararticulo: ActualizarArticulo, asignarExistencias: asignarExistenciasArt, asignarPrecios: asignarPreciosArt, sincronizarExistencia: sincronizarExistencia, sincronizarPrecio: sincronizarPrecio,
            duplicarArticulo: duplicarArticulo, desvincular: desvincularArticulo, eliminar: eliminar, cambiarFactor: cambiarFactor, cambiarStatusFull: cambiarStatusFull, duplicarArtMatriz: duplicarArtMatriz
        },
        { field: 'id', headerName: 'Id', maxWidth: 20, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        { field: 'clave', headerName: 'Clave', width: 100, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        { field: 'sku', headerName: 'SKU', width: 100, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        { field: 'nombre', headerName: 'Nombre', width: 100, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        { field: 'estatus', headerName: 'Estatus', renderCell: ({ value }) => convertStatusArticulo(value) },
        { field: 'existencias', headerName: 'Exist. Pub' },
        { field: 'costo_Unidad', headerName: 'Precio Pub', type: 'number', renderCell: ({ value }) => currency(value || 0) },
        //{ field: 'articulo_Padre_Id', headerName: 'Asignado', type: 'boolean', renderCell: ({ value }) => value !== null },
        { field: 'actStockAut', headerName: 'Act. Exist. Aut.' },
        { field: 'conexiones', headerName: 'Canales', renderCell: ({ value }) => RowConexiones(value) },
        { field: 'tiene_Variante', headerName: 'Variantes' },
        { field: 'envio_Gratis', headerName: 'Env.Gratis', type: 'boolean' },
        { field: 'es_Full', headerName: 'EsFull' },
        { field: 'url', headerName: 'URL', width: 100, renderCell: (params) => (<a href={`${params.value}`} target="_blank" rel="noreferrer">{params.value}</a>) },
        { field: 'factor', headerName: 'Factor' },
        { field: 'costo_Envio', headerName: 'C.Envio', type: 'number', renderCell: ({ value }) => currency(value || 0) },
        { field: 'costo_Comision', headerName: 'Comisión', type: 'number', renderCell: ({ value }) => currency(value || 0) },
        { field: 'metodo_Envio', headerName: 'Metodo env.' },
        { field: 'tipo_Publicacion', headerName: 'Tipo pub.' },
    ];

    if (!esPrincipal()) {
        const indexToRemove = columns.findIndex(column => column.headerName === 'Canales');
        if (indexToRemove !== -1) columns.splice(indexToRemove, 1);

        columns.splice(1, 0, {
            field: 'padre.cveOrig', headerName: 'Cve. Orig.', width: 100, cellClassName: (params) => { return 'columna-art-padre' }, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.padre?.idOrigen}?sucursal=${params.row.padre?.sucIdOrigen}`}>{params.row.padre ? params.row.padre.cveOrig : ''}</a>)
        });
        columns.splice(2, 0, {
            field: 'padre.skuOrig', headerName: 'SKU. Orig.', width: 100, cellClassName: (params) => { return 'columna-art-padre' }, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.padre?.idOrigen}?sucursal=${params.row.padre?.sucIdOrigen}`}>{params.row.padre ? params.row.padre.skuOrig : ''}</a>)
        });
        columns.splice(3, 0, {
            field: 'padre.nomOrig', headerName: 'Nom. Orig.', width: 100, cellClassName: (params) => { return 'columna-art-padre' }, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.padre?.idOrigen}?sucursal=${params.row.padre?.sucIdOrigen}`}>{params.row.padre ? params.row.padre.nomOrig : ''}</a>)
        });
        columns.splice(4, 0, {
            field: 'padre.exiOrig', headerName: 'Exi. Orig.', width: 100, cellClassName: (params) => { return 'columna-art-padre' }, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.padre?.idOrigen}?sucursal=${params.row.padre?.sucIdOrigen}`}>{params.row.padre ? params.row.padre.exiOrig : ''}</a>)
        });
        columns.splice(5, 0, {
            field: 'padre.preOrig', headerName: 'Pre. Orig.', width: 100, cellClassName: (params) => { return 'columna-art-padre' }, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.padre?.idOrigen}?sucursal=${params.row.padre?.sucIdOrigen}`}>{params.row.padre ? currency(params.row.padre.preOrig) : ''}</a>)
        });
    }

    const columnsVentaArt = [
        { field: 'id', headerName: 'Id', flex: 1, key: 'id' },
        { field: 'articulo', headerName: 'Articulo', flex: 1 },
        { field: 'movimiento', headerName: 'Movimiento', flex: 1 },
        { field: 'fecha', headerName: 'Fecha', flex: 1 },
        { field: 'no_Documento', headerName: 'No. Venta', flex: 1 },
        { field: 'folio', headerName: 'Folio', flex: 1 },
        { field: 'unidades', headerName: 'Unidades', flex: 1 },
        { field: 'existencia_Anterior', headerName: 'Existencia Anterior', flex: 1 },
        { field: 'existencia_Nueva', headerName: 'Existencias Nueva', flex: 1 },
        { field: 'tipo_Movimiento', headerName: 'Movimiento', flex: 1 },
        { field: 'almacen', headerName: 'Almacen', flex: 1 },
        { field: 'usuario', headerName: 'Usuario', flex: 1 },
        /*{ field: 'variante', headerName: 'Variante', flex: 1 ,type: 'boolean'}*/
    ];

    const columnsHistorial = [
        { field: 'fecha_Registro', headerName: 'Fecha', minWidth: 160 },
        { field: 'movimiento', headerName: 'Movimiento', minWidth: 160, renderCell: (params) => movimientoH(params.value) },
        { field: 'clave', headerName: 'Clave', minWidth: 160, renderCell: (params) => movimientoClave(params.row, params.value) },
        { field: 'movimiento_Tipo', headerName: 'Tipo', minWidth: 150, renderCell: (params) => movimientoTipo(params.value) },
        { field: 'item', headerName: 'Datos Extra', minWidth: 475, renderCell: (params) => DatosExtra(params.row) },
        { field: 'mensaje', headerName: 'Mensaje', minWidth: 300 },
        { field: 'usuario', headerName: 'Usuario', minWidth: 160 }
    ];

    return (<>
        <div className='container-fluid'>
            <div className='col-12 col-sm-12 col-md-12 row'>
                <div className='col-sm-5' >
                    <Link to={`${path}/add`} className='btn btn-outline-primary m-1'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            fill='currentColor'
                            className='bi bi-plus-square'
                            viewBox='0 0 16 16'
                        >
                            <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                            <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                        </svg>
                        &nbsp; {t('app.SwalFire.nuevo')}
                    </Link>
                    &nbsp;
                    <button
                        className='btn btn-outline-primary m-1'
                        style={{ width: 'auto' }}
                        onClick={handleClick}
                    >
                        Descargar <ArrowDropDownIcon />
                    </button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{ 'aria-labelledby': 'basic-button', }}
                    >
                        <MenuItem onClick={(e) => { DescargarTiendaEvent(); }}><ListItemIcon><svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            fill='currentColor'
                            className='bi bi-cloud-arrow-down-fill'
                            viewBox='0 0 16 16'
                        >
                            <path d='M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z' />
                        </svg></ListItemIcon>{t('app.Articulos.lista.descargarArticulos')}</MenuItem>
                        <MenuItem onClick={(e) => { opcionModal('descargarArticulo'); handleClose(); }}><ListItemIcon><svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            fill='currentColor'
                            className='bi bi-cloud-arrow-down'
                            viewBox='0 0 16 16'
                        >
                            <path fill-rule='evenodd' d='M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z' />
                            <path d='M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z' />
                        </svg></ListItemIcon>{t('app.Articulos.lista.descargarArticulo')}</MenuItem>
                    </Menu>
                    <button
                        className='btn btn-outline-primary m-1'
                        style={{ width: 'auto' }}
                        onClick={handleClickAsignacion}
                    >
                        Asignación <ArrowDropDownIcon />
                    </button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorElAsignacion}
                        open={openAsignacion}
                        onClose={handleClose}
                        MenuListProps={{ 'aria-labelledby': 'basic-button', }}
                    >
                        {getDataSession('sucursal') !== getDataSession('sucursalPrincipal') ? <>
                            <MenuItem onClick={(e) => { opcionModal('AsignacionAutomatica'); handleClose(); }}><ListItemIcon><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-collapse-vertical" viewBox="0 0 16 16">
                                <path d="M8 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M0 8a.5.5 0 0 1 .5-.5h3.793L3.146 6.354a.5.5 0 1 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L4.293 8.5H.5A.5.5 0 0 1 0 8m11.707.5 1.147 1.146a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708.708L11.707 7.5H15.5a.5.5 0 0 1 0 1z" />
                            </svg></ListItemIcon>Asignación Automatica</MenuItem>
                            {getDataSession('rol') === 'EMPRESA' || getDataSession('rol') === 'ADMINISTRADOR' ? (
                                <MenuItem onClick={(e) => { opcionModal('actualizacionCodigosSucursal'); handleClose(); }}><ListItemIcon><svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='20'
                                    height='20'
                                    fill='currentColor'
                                    className='bi bi-shop'
                                    viewBox='0 0 16 16'
                                >
                                    <path d='M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z' />
                                </svg></ListItemIcon>{t('app.Articulos.lista.asignarPorConexion')}</MenuItem>
                            ) : ('')}
                        </> : ''}
                        <MenuItem onClick={(e) => { opcionModal('actualizacionCodigosExcel'); handleClose(); }}><ListItemIcon><svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            fill='currentColor'
                            className='bi bi-file-excel'
                            viewBox='0 0 16 16'
                        >
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>{t('app.Articulos.lista.asignarPorExcel')}</MenuItem>
                        <MenuItem onClick={(e) => { asignarImpuestos16(); handleClose(); }}><ListItemIcon><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-wallet-fill" viewBox="0 0 16 16">
                            <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542s.987-.254 1.194-.542C9.42 6.644 9.5 6.253 9.5 6a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2z" />
                            <path d="M16 6.5h-5.551a2.7 2.7 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5s-1.613-.412-2.006-.958A2.7 2.7 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5z" />
                        </svg>
                        </ListItemIcon>Asignar Impuesto 16%</MenuItem>
                    </Menu>
                </div>
                <div className='col-sm-2 text-right' >
                    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="almacen-multiple-checkbox-label">Filtros</InputLabel>
                        <Select
                            labelId="almacen-multiple-checkbox-label"
                            id="almacen-multiple-checkbox"
                            onChange={handleChangeFiltros}
                            value={filtro}
                            label="Filtros"
                        >
                            <MenuItem key="TodosFiltros" value="T">
                                <ListItemText primary="Todos" />
                            </MenuItem>
                            <MenuItem key="Asignados" value="ASIGNADO">
                                <ListItemText primary="Asignados" />
                            </MenuItem>
                            <MenuItem key="NoAsignados" value="N_ASIGNADO" va>
                                <ListItemText primary="No Asignados" />
                            </MenuItem>
                            <MenuItem key="ConVariantes" value="VARIANTE">
                                <ListItemText primary="Con Variantes" />
                            </MenuItem>
                            <MenuItem key="Sin Variantes" value="N_VARIANTE">
                                <ListItemText primary="Sin Variantes" />
                            </MenuItem>
                            <MenuItem key="ArticulosFull" value="FULL">
                                <ListItemText primary="Articulos Full" />
                            </MenuItem>
                            <MenuItem key="SinSKU" value="N_SKU">
                                <ListItemText primary="Sin SKU" />
                            </MenuItem>
                            <MenuItem key="SinImagenes" value="S_IMAGEN" >
                                <ListItemText primary="Sin Imagenes" />
                            </MenuItem>
                            {getDataSession('tienda') === 'MERCADOLIBRE' && (
                                <MenuItem key="SinImagenes" value="CATALOGO" >
                                    <ListItemText primary="Articulos de Catalogo" />
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </div>
                <div className='col-sm-2 text-right' >
                    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="almacen-multiple-checkbox-label">Estatus</InputLabel>
                        <Select
                            labelId="almacen-multiple-checkbox-label"
                            id="almacen-multiple-checkbox"
                            onChange={handleChangeStatus}
                            value={status}
                            label="Estatus"
                        >
                            <MenuItem key="TodosEstatus" value="T">
                                <ListItemText primary="Todos" />
                            </MenuItem>
                            <MenuItem key="Activos" value="ACTIVOS">
                                <ListItemText primary="Activos" />
                            </MenuItem>
                            <MenuItem key="Pausados" value="PAUSADOS" va>
                                <ListItemText primary="Pausados" />
                            </MenuItem>
                            <MenuItem key="Inactivos" value="INACTIVOS">
                                <ListItemText primary="Inactivos" />
                            </MenuItem>
                            {/*<MenuItem key="Archivados" value="ARCHIVADOS">
                                <ListItemText primary="Archivados" />
                            </MenuItem>*/}
                            <MenuItem key="Borrador" value="BORRADOR">
                                <ListItemText primary="En Borrador" />
                            </MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className='col-sm-3 text-right'>
                    <button
                        className='btn btn-outline-primary m-1'
                        style={{ width: 'auto' }}
                        onClick={handleClickHerramientas}
                    >
                        {t('app.botones.herramientas')} <ArrowDropDownIcon />
                    </button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorElHerramientas}
                        open={openHerramientas}
                        onClose={handleClose}
                        MenuListProps={{ 'aria-labelledby': 'basic-button', }}
                    >
                        {getDataSession('sucursalPrincipal') === getDataSession('sucursal') ? '' :
                            <MenuItem onClick={() => { history.push(`${SLUGS.diferencias}`); handleClose(); }}><ListItemIcon><CompareArrowsIcon /></ListItemIcon>Comparativa</MenuItem>
                        }
                        <MenuItem onClick={() => { exportarArticulos(); }}><ListItemIcon><svg xmlns='http://www.w3.org/2000/svg' width='20' eight='20' fill='currentColor' className='bi bi-file-excel' viewBox='0 0 16 16'>
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>{t('app.Articulos.lista.exportarArticulo')}</MenuItem>
                        <MenuItem onClick={() => { exportarArticulos(true); }}><ListItemIcon><svg xmlns='http://www.w3.org/2000/svg' width='20' eight='20' fill='currentColor' className='bi bi-file-excel' viewBox='0 0 16 16'>
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>{t('app.Articulos.lista.exportarArticulo')} Asignados</MenuItem>
                        <MenuItem onClick={() => { setModalValor('pulicadorMasivo'); setModalKey(prev => prev + 1); openModalMarketPlace(); handleClose(); }}><ListItemIcon>
                            <WebStoriesIcon />
                        </ListItemIcon>{t('app.Articulos.pulicadorMasivo')}
                        </MenuItem>
                        {/*<MenuItem onClick={() => { setModalValor('duplicarArticulosEcommerce'); openModalMarketPlace(); handleClose(); }}><ListItemIcon>
                            <WebStoriesIcon />
                            </ListItemIcon>Enviar aticulos a otro Canal
                        </MenuItem>*/}
                        <MenuItem onClick={() => { DuplicarArtiulos(); handleClose(); }}><ListItemIcon>
                            <WebStoriesIcon />
                        </ListItemIcon>Enviar aticulos{(getDataSession('sucursal') !== getDataSession('sucursalPrincipal') ? ' a matriz' : ' a ecommerce')}
                        </MenuItem>
                        {usaFactor() && <MenuItem onClick={() => { opcionModal('importarFactorExcel'); handleClose(); }}><ListItemIcon><svg xmlns='http://www.w3.org/2000/svg' width='20' eight='20' fill='currentColor' className='bi bi-file-excel' viewBox='0 0 16 16'>
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>Importar Factor
                        </MenuItem>}
                        {getDataSession('sucursal') === getDataSession('sucursalPrincipal') && <MenuItem onClick={() => { opcionModal('importarArticulosExcel'); handleClose(); }}><ListItemIcon><svg xmlns='http://www.w3.org/2000/svg' width='20' eight='20' fill='currentColor' className='bi bi-file-excel' viewBox='0 0 16 16'>
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>Importar articulos
                        </MenuItem>}
                        <MenuItem onClick={() => { opcionModal('importarPreciosExcel'); handleClose(); }}><ListItemIcon><svg xmlns='http://www.w3.org/2000/svg' width='20' eight='20' fill='currentColor' className='bi bi-file-excel' viewBox='0 0 16 16'>
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>Importar Precios
                        </MenuItem>
                        <MenuItem onClick={() => { opcionModal('importarExistenciasExcel'); handleClose(); }}><ListItemIcon><svg xmlns='http://www.w3.org/2000/svg' width='20' eight='20' fill='currentColor' className='bi bi-file-excel' viewBox='0 0 16 16'>
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>Importar Existencias
                        </MenuItem>
                        <MenuItem onClick={() => { opcionModal('importarExistenciasPreciosExcel'); handleClose(); }}><ListItemIcon><svg xmlns='http://www.w3.org/2000/svg' width='20' eight='20' fill='currentColor' className='bi bi-file-excel' viewBox='0 0 16 16'>
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>Importar Existencias/Precios
                        </MenuItem>
                        <MenuItem onClick={() => { opcionModal('sincronizacionExcel'); handleClose(); }}><ListItemIcon><svg xmlns='http://www.w3.org/2000/svg' width='20' eight='20' fill='currentColor' className='bi bi-file-excel' viewBox='0 0 16 16'>
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>Sincronización de articulos
                        </MenuItem>
                        {usaSelectFull() && <MenuItem onClick={() => { opcionModal('ActualizarEstatusFullExcel'); handleClose(); }}><ListItemIcon><svg xmlns='http://www.w3.org/2000/svg' width='20' eight='20' fill='currentColor' className='bi bi-file-excel' viewBox='0 0 16 16'>
                            <path d='M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z' />
                            <path d='M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z' />
                        </svg></ListItemIcon>Actualizar estatus FULL
                        </MenuItem>}
                    </Menu>
                    <p>{mensajeArticulosDescargados}</p>
                    <p>{mensajeArticulosSincronizados}</p>
                    <p>{mensajeArticulosImportados}</p>
                </div>
            </div>
            <div className='col-md-12'>
                <ListTable
                    columns={columns}
                    path={path}
                    url={`Articulos/GetList?sucursal_Id=${getDataSession('sucursal')}&filtro=${filtro}${status ? "&status=" + status : ''}`}
                    isTreeData={true}
                    reload={actualizarTabla}
                    setBuscar={setBuscar}
                />
            </div>
        </div>
        <Modal key={modalKey} isOpen={isOpenModal} closeModal={closeModal}><br />
            {modalValor === 'verVentasArticulo' && <div className='card text-left' style={{ padding: 10, height: "80vh" }}>
                <ListTable
                    columns={columnsVentaArt}
                    path={path}
                    url={`Existencias/HistorialExistencias/GetList?articulo_Id=${articuloId}&movimiento=${movimiento === null ? '' : movimiento}`}
                    hideConexion={true}
                />
            </div>}
            {modalValor === 'AsignacionArticulo' && <div className='card text-left' style={{ padding: 10 }}>
                <h6>Asignacion de articulos</h6>
                <div className='container'>
                    <div className=' row'>
                        <h7>
                            La asignacion automatica ligara el articulo de su conexión actual con la conexión principal, se utilizaran las claves del articulo asigandas al rol proporcionado.
                        </h7>
                        {asignacion?.automatica === "false" ?
                            <>
                                <div className='col-md-12'>
                                    <div className='card mb-2 '>
                                        <div className='card-title text-start'>
                                            <label><b>Seleccione el articulo de la <b>conexión principal</b> para ligar los articulos</b></label>
                                        </div>
                                        {isOpenModal && <div className='card-body text-start'>
                                            <AsyncSelectTextField
                                                getOptionLabel={(option) => option.clave + ' - ' + option.nombre}
                                                getOptionValue={(option) => option.id}
                                                valueSelectTo={asignacion}
                                                resIsTableMode
                                                setValueSelectTo={(selectedItem) => {
                                                    const val = selectedItem === null ? '' : selectedItem?.id;
                                                    getArticulo(val);
                                                }}
                                                url={`Articulos/GetList?paginas=0&totalXpagina=50&sucursal_Id=${sucursalPrincipal.id}`}
                                            />
                                        </div>}
                                    </div>
                                </div>
                            </> : <>
                                <div className='col-md-6'>
                                    <div className='card mb-2 '>
                                        <div className='card-title text-start'>
                                            <label>Utilizar el siguiente rol de clave de la <b>conexión actual</b> para ligar los articulos</label>
                                        </div>
                                        <div className='card-body text-start'>
                                            <select
                                                className='form-control'
                                                name='lista_clave_tienda_id'
                                                value={asignacion?.lista_clave_tienda_id}
                                                onChange={handleInputAsignacion}
                                                required
                                            >
                                                <option >Seleccione un rol de clave</option>
                                                {rolClavesTienda.map((rol) => {
                                                    return (
                                                        <option key={rol.id} value={rol.id}>
                                                            {rol.nombre}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='card mb-2 '>
                                        <div className='card-title text-start'>
                                            <label><b>Utilizar el siguiente rol de clave de la <b>conexión principal</b> para ligar los articulos</b></label>
                                        </div>
                                        <div className='card-body text-start'>
                                            <select
                                                className='form-control'
                                                name='lista_clave_principal_id'
                                                value={asignacion?.lista_clave_principal_id}
                                                onChange={handleInputAsignacion}
                                                required
                                            >
                                                <option >Seleccione un rol de clave</option>
                                                {rolClavesPrincipal.map((rol) => {
                                                    return (
                                                        <option key={rol.id} value={rol.id}>
                                                            {rol.nombre}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </>}
                        &nbsp;&nbsp;
                        <button
                            className='btn btn-outline-primary'
                            onClick={(e) => AsignacionArticulo()}
                            style={{ maxWidth: '300px' }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-collapse-vertical" viewBox="0 0 16 16">
                                <path d="M8 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M0 8a.5.5 0 0 1 .5-.5h3.793L3.146 6.354a.5.5 0 1 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L4.293 8.5H.5A.5.5 0 0 1 0 8m11.707.5 1.147 1.146a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708.708L11.707 7.5H15.5a.5.5 0 0 1 0 1z" />
                            </svg>
                            &nbsp; Iniciar la asignación
                        </button>
                    </div>
                </div>
            </div>}
            {modalValor === 'AsignacionAutomatica' && <div className='card text-left' style={{ padding: 10 }}>
                <p>{mensajeAsignacion}</p>
                <p>{mensajeAsignacionVariante}</p>
                <p>{mensajeAsignacionMensaje}</p>
                <br></br>
                <hr></hr>
                <h6>Asignacion automatica</h6>
                <div className='container'>
                    <div className=' row'>
                        <h7>
                            La asignacion automatica ligara los articulos de su conexión actual con la conexión principal, se utilizaran las claves del articulo asigandas al rol proporcionado.
                        </h7>
                        <div className='col-md-6'>
                            <div className='card mb-2 '>
                                <div className='card-title text-start'>
                                    <label>Utilizar el siguiente rol de clave de la <b>conexión actual</b> para ligar los articulos</label>
                                </div>
                                <div className='card-body text-start'>
                                    <select
                                        className='form-control'
                                        name='lista_clave_tienda_id'
                                        value={asignacion?.lista_clave_tienda_id}
                                        onChange={handleInputAsignacion}
                                        required
                                    >
                                        <option ></option>
                                        {rolClavesTienda.map((rol) => { return (<option key={rol.id} value={rol.id}>{rol.nombre}</option>); })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='card mb-2 '>
                                <div className='card-title text-start'>
                                    <label><b>Utilizar el siguiente rol de clave de la <b>conexión principal</b> para ligar los articulos</b></label>
                                </div>
                                <div className='card-body text-start'>
                                    <select
                                        className='form-control'
                                        name='lista_clave_principal_id'
                                        value={asignacion?.lista_clave_principal_id}
                                        onChange={handleInputAsignacion}
                                        required
                                    >
                                        <option ></option>
                                        {rolClavesPrincipal.map((rol) => {
                                            return (
                                                <option key={rol.id} value={rol.id}>
                                                    {rol.nombre}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        &nbsp;&nbsp;
                        <button
                            className='btn btn-outline-primary'
                            onClick={(e) => AsignacionAutomatica()}
                            style={{ maxWidth: '200px' }}
                        >
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='20'
                                height='20'
                                fill='currentColor'
                                className='bi bi-plus-square'
                                viewBox='0 0 16 16'
                            >
                                <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                                <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                            </svg>
                            &nbsp; Iniciar la asignación automatica
                        </button>
                    </div>
                </div>
            </div>}
            {modalValor === 'descargarArticulo' && <div className='card text-left' style={{ padding: 10 }}>
                <h6>{!isERP() ? 'E-Commerce' : erp}</h6>
                <div className='container'>
                    <div className=' row'>
                        {!isERP() ? <h7>
                            Descargar un articulo de E-Commerce, mediante la clave del articulo
                        </h7> : <h7>
                            Descargar un articulo de {erp}, mediante el sku del articulo
                        </h7>}
                        <input
                            type='text'
                            className='form-control'
                            name='nombre'
                            style={{ width: '320px' }}
                            placeholder={!isERP() ? 'Clave del articulo de Marketplace' : 'SKU del articulo de ERP'}
                            value={CodigoArticulo || ''}
                            onChange={handleInputChange}
                        />
                        &nbsp;&nbsp;
                        <button
                            className='btn btn-outline-primary'
                            onClick={(e) => DescargarArticulo()}
                            style={{ maxWidth: '200px' }}
                        >
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='20'
                                height='20'
                                fill='currentColor'
                                className='bi bi-plus-square'
                                viewBox='0 0 16 16'
                            >
                                <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                                <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                            </svg>
                            &nbsp; {t('app.Articulos.lista.descargarArticulo')}
                        </button>
                    </div>
                </div>
            </div>}
            {modalValor === 'descargarArticulos' && <div className='card text-left' style={{ padding: 10 }}>
                <div className='container'>
                    <div className='row'>
                        <div className='espacio10px' />
                        <div className='col-md-10'><h7>Descargar los Articulos de E-Commerce:</h7></div>
                        <div className='col-md-2 text-right'>
                            <button
                                className='btn btn-outline-primary '
                                onClick={(e) => DescargarTienda()}
                                style={{ maxWidth: '200px' }}
                            >
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='20'
                                    height='20'
                                    fill='currentColor'
                                    className='bi bi-plus-square'
                                    viewBox='0 0 16 16'
                                >
                                    <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                                    <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                                </svg>
                                &nbsp; Descargar
                            </button>
                        </div>
                        {tienda === 'SHOPIFY' && <div className='row'>
                            <div className='col-md-2 text-right'>
                                <FormControlLabel control={<Checkbox name='usaFecha' checked={usaFecha} onChange={handelChangeSelect} />} label="Usar Fecha" />
                            </div>
                            <div className='col-md-3'>
                                <TextField sx={{ m: 1, width: 250 }} size="small"
                                    label="Fecha"
                                    type="date"
                                    disabled={!usaFecha}
                                    value={fechaDescarga}
                                    onChange={handleInputChangeFechaDescarga}
                                    InputLabelProps={{ shrink: true, }}
                                />
                            </div>
                            <div className='col-md-2'><TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small" label="Marca" value={marcaDescarga} onChange={handleChangeMarcaDescarga} /></div>
                            <div className='col-md-2'>
                                <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
                                    <InputLabel id="almacen-multiple-checkbox-label">Estatus</InputLabel>
                                    <Select
                                        labelId="almacen-multiple-checkbox-label"
                                        id="almacen-multiple-checkbox"
                                        onChange={handleChangeStatusDescarga}
                                        value={statusDescarga}
                                        label="Estatus"
                                    >
                                        <MenuItem key="ACTIVE" value="ACTIVE">
                                            <ListItemText primary="Activos / Pausados" />
                                        </MenuItem>
                                        <MenuItem key="ARCHIVED" value="ARCHIVED">
                                            <ListItemText primary="Archivados" />
                                        </MenuItem>
                                        <MenuItem key="DRAFT" value="DRAFT">
                                            <ListItemText primary="En Borrador" />
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>}
            {modalValor === 'actualizacionCodigosExcel' && <div className='card text-left' style={{ padding: 10 }}>
                <h6>{t('app.Articulos.actualizacionCodigos')}</h6>
                <div className='container'>
                    <div className='container text-right'>
                        <button className='btn btn-outline-success' type='button' onClick={() => descargarPlantilla()}>Descargar Plantilla</button>
                        &nbsp;
                        &nbsp;
                        <button
                            className='btn btn-outline-primary '
                            type='button'
                            onClick={() => actualizarCodigos()}
                            style={{ maxWidth: '200px' }}
                        >
                            Cargar codigos
                        </button>
                        <br></br>
                    </div>
                    <br></br>
                    <div className='row'>
                        <div className='col-md-6'>
                            <h7>Configurar codigos mediante excel:</h7>&nbsp;
                            <input
                                type='file'
                                onChange={handleInputChangeFileConfig}
                                style={{ maxWidth: '320px' }}
                            />
                        </div>
                        <div className='col-md-6'>
                            <h7>
                                Conexión de destino: &nbsp;
                                &nbsp;
                            </h7>
                            <select
                                className='form-control'
                                onChange={handleChangeDes}
                                value={sucursalIdDes}
                                style={{ with: '350px' }}
                            >
                                {sucursalesList?.map((item) => { return (<option value={item.id} key={item.id}> {item.nombre} </option>); })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>}
            {modalValor === 'sincronizacionExcel' && <div className='card text-left' style={{ padding: 10 }}>
                <h6>Sincronización de articulos</h6>
                <div className='container'>
                    <div className='container text-right'>
                        <button className='btn btn-outline-success' type='button' onClick={() => descargarPlantilla()}>Descargar Plantilla</button>
                        &nbsp;
                        &nbsp;
                        <button
                            className='btn btn-outline-primary '
                            type='button'
                            onClick={() => sincronizarArticulos()}
                            style={{ maxWidth: '200px' }}
                        >
                            Sincronizar por Archivo
                        </button>
                        &nbsp;
                        &nbsp;
                        <button
                            className='btn btn-outline-primary '
                            type='button'
                            onClick={() => sincronizarArticulosCanal()}
                            style={{ maxWidth: '200px' }}
                        >
                            Sincronizar Canal Actual
                        </button>
                        <br></br>
                    </div>
                    <br></br>
                    <div className='row'>
                        <div className='col-md-6'>
                            <h7>Sincronizar mediante excel:</h7>&nbsp;
                            <input
                                type='file'
                                onChange={handleInputChangeFileConfig}
                                style={{ maxWidth: '320px' }}
                            />
                        </div>
                        <div className='col-md-6'>
                            <h7>
                                Conexión de destino: &nbsp;
                                &nbsp;
                            </h7>
                            <select
                                className='form-control'
                                onChange={handleChangeDes}
                                value={sucursalIdDes}
                                style={{ with: '350px' }}
                            >
                                {sucursalesList?.map((item) => { return (<option value={item.id} key={item.id}> {item.nombre} </option>); })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>}
            {modalValor === 'importarArticulosExcel' && <div className='card text-left' style={{ padding: 10 }}>
                <h6>Importar articulos</h6>
                <div className='container'>
                    <div className='container text-right'>
                        <button className='btn btn-outline-success' type='button' onClick={() => descargarPlantilla()}>Descargar Plantilla</button>
                        &nbsp;
                        &nbsp;
                        <button
                            className='btn btn-outline-primary '
                            type='button'
                            onClick={() => importarArticulos()}
                            style={{ maxWidth: '200px' }}
                        >
                            Importar
                        </button>
                        <br></br>
                    </div>
                    <br></br>
                    <div className='row'>
                        <div className='col-md-6'>
                            <h7>Importar mediante excel:</h7>&nbsp;
                            <input
                                type='file'
                                onChange={handleInputChangeFileConfig}
                                style={{ maxWidth: '320px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>}
            {(modalValor === 'importarExistenciasExcel' || modalValor === 'importarPreciosExcel' || modalValor === 'importarExistenciasPreciosExcel') && <div className='card text-left' style={{ padding: 10 }}>
                <h6>Importar {modalValor === 'importarPreciosExcel' ? 'Precios' : (modalValor === 'importarExistenciasExcel' ? 'Existencias' : 'Existencias/Precios')}</h6>
                <div className='container'>
                    <div className='container text-right'>
                        <button className='btn btn-outline-success' type='button' onClick={() => descargarPlantilla()}>Descargar Plantilla</button>
                        &nbsp;
                        &nbsp;
                        <button
                            className='btn btn-outline-primary '
                            type='button'
                            onClick={() => importarPreciosExistencias()}
                            style={{ maxWidth: '200px' }}
                        >
                            Importar
                        </button>
                        <br></br>
                    </div>
                    <br></br>
                    <div className='row'>
                        <div className='col-md-6'>
                            <h7>Importar mediante excel:</h7>&nbsp;
                            <input
                                type='file'
                                onChange={handleInputChangeFileConfig}
                                style={{ maxWidth: '320px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>}
            {modalValor === 'ActualizarEstatusFullExcel' && <div className='card text-left' style={{ padding: 10 }}>
                <h6>Actualizar estatus FULL</h6>
                <div className='container'>
                    <div className='container text-right'>
                        <button className='btn btn-outline-success' type='button' onClick={() => descargarPlantilla()}>Descargar Plantilla</button>
                        &nbsp;
                        &nbsp;
                        <button
                            className='btn btn-outline-primary '
                            type='button'
                            onClick={() => actualizarEstatusFull()}
                            style={{ maxWidth: '200px' }}
                        >
                            Actualizar
                        </button>
                        <br></br>
                    </div>
                    <br></br>
                    <div className='row'>
                        <div className='col-md-6'>
                            <h7>Actualizar mediante excel:</h7>&nbsp;
                            <input
                                type='file'
                                onChange={handleInputChangeFileConfig}
                                style={{ maxWidth: '320px' }}
                            />
                        </div>
                        <div className='col-md-6'>
                            <h7>Conexión de destino: &nbsp;&nbsp;</h7>
                            <select
                                className='form-control'
                                onChange={handleChangeDes}
                                value={sucursalIdDes}
                                style={{ with: '350px' }}
                            >
                                {sucursalesList?.map((item) => { return (<option value={item.id} key={item.id}> {item.nombre} </option>); })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>}
            {modalValor === 'actualizacionCodigosSucursal' && <div className='card text-left' style={{ padding: 10 }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12 row'>
                            <h6>Actualización de códigos respecto a las conexiones</h6>
                            <small>Asignara los códigos: Clave Prod. Serv.,No. Identificacion,Clave Unidad. Mediante la comparación de SKU </small>
                        </div>
                        <div className='col-md-6'>
                            <h7>
                                Conexión de origen: &nbsp;
                                &nbsp;
                            </h7>
                            <select
                                className='form-control'
                                onChange={handleChangeOri}
                                value={sucursalIdOri}
                                style={{ with: '350px' }}
                            >
                                {sucursalesList?.map((item) => { return (<option value={item.id} key={item.id}> {item.nombre}</option>); })}
                            </select>
                        </div>
                        <div className='col-md-6'>
                            <h7>
                                Conexión de destino: &nbsp;
                                &nbsp;
                            </h7>
                            <select
                                className='form-control'
                                onChange={handleChangeDes}
                                value={sucursalIdDes}
                                style={{ with: '350px' }}
                            >
                                {sucursalesList?.map((item) => { return (<option value={item.id} key={item.id}>{item.nombre}</option>); })}
                            </select>
                        </div>
                        <div className='col-md-12 text-right'>
                            <br></br>
                            <button
                                className='btn btn-outline-primary'
                                type='button'
                                onClick={() => actualizarCodigosXSucursal()}
                            >
                                Actualizar codigos
                            </button>
                        </div>
                    </div>
                </div>
            </div>}
            {modalValor === 'verVariantesArticulo' && <>{dataArt ? <ListVariante data={dataArt} variantes={dataArt.articulo_Variantes} editar={false} /> : <Cargando />}</>}
            {modalValor === 'verHistorialArticulo' && <div className='card' style={{ height: "50vh" }}>
                <div className='col-md-12'>
                    <div className='espacio5px' />
                    <div className='col-12 col-sm-12 col-md-12 row'>
                        <div className='col-sm-1'><div className='espacio10px' /><label className='form-label title2'>&nbsp; Historial</label></div>
                        <div className='col-sm-7' />
                        <div className='col-sm-2'>
                            <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
                                <InputLabel id="tipo-label">Tipo</InputLabel>
                                <Select id="tipo" labelId="tipo-label" label="Tipo" onChange={handleChangeTipo} value={filtroTipo}>
                                    <MenuItem key="TodosFiltros" value="T"><ListItemText primary="Todos" /></MenuItem>
                                    <MenuItem key="Asignados" value="AGREGADO"><ListItemText primary="Agregado" /></MenuItem>
                                    <MenuItem key="NoAsignados" value="ACTUALIZADO"><ListItemText primary="Actualizado" /></MenuItem>
                                    <MenuItem key="ConVariantes" value="DESCARGADO"><ListItemText primary="Descargado" /></MenuItem>
                                    <MenuItem key="Asignados" value="OMITIDO"><ListItemText primary="Omitido" /></MenuItem>
                                    <MenuItem key="ConVariantes" value="ERROR"><ListItemText primary="Error" /></MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-sm-2'>
                            <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                                label="Fecha"
                                type="date"
                                value={fechaInicio}
                                onChange={handleInputChangeFechaInicio}
                                InputLabelProps={{ shrink: true, }}
                            />
                        </div>
                    </div>
                </div>
                <ListTable
                    columns={columnsHistorial}
                    url={`LogNotificacion/Historial/GetListByMovimiento?sucursal_id=${getDataSession('sucursal')}&movimiento_id=${articuloId}&movimiento=ARTICULO&fecha=${fechaInicio}${GetFiltroTipo()}`}
                    hideSearch={true}
                    reload={actualizarTabla}
                />
            </div>}
            {modalValor === 'AsignarFactorArt' && <div className='card text-left' style={{ padding: 10 }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-3' />
                        <div className='col-md-5'>
                            <label htmlFor='calle'>Factor:</label>&nbsp;
                            <input
                                type='number'
                                value={factor}
                                onChange={handleChangeFactor}
                                className='form-control'
                                style={{ maxWidth: '320px' }}
                            />
                        </div>
                        <div className='col-md-3'>
                            <div className='espacio30px' />
                            <button
                                type='button'
                                onClick={asignarFactor}
                                className='btn btn-outline-primary'
                            >
                                Asignar Factor
                            </button>
                        </div>
                        <div className='col-md-1' />
                    </div><br />
                </div>
            </div>}
            {modalValor === 'importarFactorExcel' && <div className='card text-left' style={{ padding: 10 }}>
                <h6>Actualizar Factor</h6>
                <div className='container'>
                    <div className='container text-right'>
                        <button className='btn btn-outline-success' type='button' onClick={() => descargarPlantilla()}>Descargar Plantilla</button>
                        &nbsp;
                        &nbsp;
                        <button
                            className='btn btn-outline-primary '
                            type='button'
                            onClick={() => importarFactor()}
                            style={{ maxWidth: '200px' }}
                        >
                            Actualizar
                        </button>
                        <br></br>
                    </div>
                    <br></br>
                    <div className='row'>
                        <div className='col-md-6'>
                            <h7>Actualizar mediante excel:</h7>&nbsp;
                            <input
                                type='file'
                                onChange={handleInputChangeFileConfig}
                                style={{ maxWidth: '320px' }}
                            />
                        </div>
                        <div className='col-md-6'>
                            <h7>Conexión de destino: &nbsp;&nbsp;</h7>
                            <select
                                className='form-control'
                                onChange={handleChangeDes}
                                value={sucursalIdDes}
                                style={{ with: '350px' }}
                            >
                                {sucursalesList?.map((item) => { return (<option value={item.id} key={item.id}> {item.nombre} </option>); })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>}
            {modalValor === 'asignarExistencias' && <AsignarExistenciasArticulo
                id={articuloId}
                GetSucursalId={getDataSession('sucursal')}
                articulo={dataArt}
                setArticulo={setDataArt}
                setReload={setActualizarTabla}
                closeModal={closeModal}
            />}
            {modalValor === 'asignarPrecios' && <AsignarPreciosArticulo
                id={articuloId}
                GetSucursalId={getDataSession('sucursal')}
                articulo={dataArt}
                setArticulo={setDataArt}
                setReload={setActualizarTabla}
                closeModal={closeModal}
            />}
        </Modal>
        <Modal key={modalKey} isOpen={isOpenModalMarketPlace} closeModal={closeModalMarketPlace}>
            {(modalValor === 'duplicarArticulo' || modalValor === 'duplicarArticulos') && (<SelectorConexion sucursalesTienda={sucursales} setSucursalesTienda={setSucursales} onClickButton={duplicarArticuloOnClick} usaFactor={true} multiple={true} />)}
            {modalValor === 'enviarArticulosDeMatriz' && (<SelectorConexion sucursalesTienda={sucursales} setSucursalesTienda={setSucursales} multiple={false} onClickButton={duplicarArticulosMatrizOnClick} />)}
            {(modalValor === 'pulicadorMasivo' || modalValor === 'duplicarArticuloEcommerce' || modalValor === 'duplicarArticulosEcommerce') && (<>
                <div className='espacio15px' />
                <h4 className='text-center'>Seleccione su e-Commerce</h4>
                <div className='col-md-12 row'>
                    <div className='col-sm-1' />
                    <div className='col-md-11 row'>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { PublicadorMasivo('MercadoLibre') }}>
                            <img src={mercadolibre} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { PublicadorMasivo('WooCommerce') }}>
                            <img src={woocommerce} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { PublicadorMasivo('Shopify') }}>
                            <img src={shopify} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { PublicadorMasivo('TiendaNube') }}>
                            <img src={tiendanube} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { PublicadorMasivo(noDisponible) }}>
                            <img src={amazon} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { PublicadorMasivo(noDisponible) }}>
                            <img src={wix} />
                        </button>
                    </div>
                </div>
            </>)}
            {(modalValor === 'duplicarArticulosMatriz') && (<>
                <div className='espacio15px' />
                <h4 className='text-center'>Seleccione su e-Commerce</h4>
                <div className='col-md-12 row'>
                    <div className='col-sm-1' />
                    <div className='col-md-11 row'>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { DuplicarArticulosMatriz(noDisponible) }}>
                            <img src={mercadolibre} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { DuplicarArticulosMatriz('WooCommerce') }}>
                            <img src={woocommerce} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { DuplicarArticulosMatriz('Shopify') }}>
                            <img src={shopify} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { DuplicarArticulosMatriz('TiendaNube') }}>
                            <img src={tiendanube} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { DuplicarArticulosMatriz(noDisponible) }}>
                            <img src={amazon} />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { DuplicarArticulosMatriz(noDisponible) }}>
                            <img src={wix} />
                        </button>
                    </div>
                </div>
            </>)}
        </Modal>
    </>);
};

export { List };